module.exports = __webpack_public_path__ + "img/row.89f88dd9.png";